import { Button, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material'
import cx from 'classnames'
import React from 'react'
import { Mutation } from 'react-apollo'
import { useHistory } from 'react-router-dom'
import { i18n } from '../index'
import css from './weeklyInfoPage.css'
import { upsertWeeklyInfo } from './weeklyInfoQueries'
import type { SubjectType } from './weeklyInfoTypes'

type RequiresActionProps = {
  stationId: string
  date: string
  weeklyInfoId?: string
  subject: SubjectType
  isActionRequired?: boolean | null
  showCreateTaskButton?: boolean
  callback?: (...args: Array<any>) => any
  refetch?: (...args: Array<any>) => any
}

export default function RequiresAction({
  subject,
  stationId,
  date,
  weeklyInfoId: id,
  callback,
  refetch,
  showCreateTaskButton,
  isActionRequired,
}: RequiresActionProps) {
  let initialValue = ''
  if (isActionRequired === true) {
    initialValue = 'yes'
  } else if (isActionRequired === false) {
    initialValue = 'no'
  }
  const [isActionRequiredState, setIsActionRequiredState] = React.useState<string>(initialValue)
  const history = useHistory()

  const onChange = async (onMutate: (...args: Array<any>) => any, radioState: string) => {
    if (radioState === '') {
      return
    }
    setIsActionRequiredState(radioState)
    const required = radioState === 'yes'
    if (callback) {
      callback(required)
    } else {
      await onMutate({
        variables: {
          stationId,
          date,
          weeklyInfo: {
            id,
            isActionRequired: required,
          },
        },
      })

      if (refetch) {
        refetch()
      }
    }
  }

  const onCreateTask = () => {
    history.push('/tehtavalista/uusi-tehtava', {
      subject: subject,
    })
  }

  return (
    <div className={css.requiresAction}>
      <Mutation mutation={upsertWeeklyInfo}>
        {(onMutate) => (
          <FormControl component='fieldset'>
            <RadioGroup
              value={isActionRequiredState}
              onChange={(e) => onChange(onMutate, e.target.value)}
              className={css.formControls}
            >
              <FormControlLabel value='no' control={<Radio />} label={i18n.t('buttons.no')} />
              <FormControlLabel value='yes' control={<Radio />} label={i18n.t('buttons.yes')} />
            </RadioGroup>
          </FormControl>
        )}
      </Mutation>
      {showCreateTaskButton !== false && isActionRequiredState === 'yes' && (
        <Button
          className={cx(css.createTaskButton, {
            [css.createTaskButtonVisible]: isActionRequiredState,
          })}
          color='primary'
          onClick={onCreateTask}
        >
          {i18n.t('weeklyInfo.button.createTask')}
        </Button>
      )}
    </div>
  )
}
